import React, { useEffect, useRef, useState } from "react";

import { GenericTable, Input, toastMessage, Button, tCell, Dialog, ActionMenu, Dropdown, Checkbox, ConfirmationDialog } from "../utils/index";
import { buttonClasses } from "../utils/theme";
import { useCheckpoints, useOrgs, usePlant, useProductCategories, useUserDetail, useUserPermissions } from "../../services/hooks";
import { fakeFileInput, formatDate, isObjectEqual } from "../../services/functions";
import { useAddProductCategoryMutation, useDeleteProductCategoryMutation, useUpdateProductCategoryMutation, useUploadProductCategoryMutation } from "../../api/vmsSlice";
import { Navigate } from "react-router-dom/dist";
import Genericfilter from "../utils/Genericfilter";
import { debounce } from "../../services/functions";
import { Grid } from "@mui/material";
import { GenericstatsV2 } from "../utils/Genericstats";
import CommonTour, { TourIcon } from "../Tour/CommonTour";
import { usePlantContext } from "../../context/plantContext";
const dummyTourData = [
	{
		_id: "67fe40a51a54c181c24cc5c9",
		productCategory: "Organic Matter",
		orgId: "65af5e42b41c7ab7ed1119ff",
		orgName: "LVMH",
		productCategoryId: "",
		prefix: "",
		checkpoints: [],
		created_by: {
			user_id: "632c5cd8a62a978fd33d4b8c",
			user_type: "superAdmin",
			name: "Shubham",
			email: "shubham.a@lynkit.in",
		},
		created_on: "2025-04-15T11:19:01.316Z",
		modified_by: {
			user_id: "632c5cd8a62a978fd33d4b8c",
			user_type: "superAdmin",
			name: "Shubham",
			email: "shubham.a@lynkit.in",
		},
		modified_on: "2025-04-15T11:19:01.316Z",
		__v: 0,
	},
];

const ProductCategoriesTour = [
	{
		target: ".title",
		content: "Welcome to Product Category Management! Here you can organize and manage your product categories.",
		placement: "bottom",
	},
	// {
	//   target: '.genericStats-containter',
	//   content: 'These cards provide an overview of your product category statistics.',
	//   placement: 'bottom'
	// },
	{
		target: "#Genericfilter",
		content: "Filter product categories by name or organization to find specific entries quickly.",
		placement: "bottom",
	},
	{
		target: ".addProductCategory",
		content: "Create new product categories individually using this button.",
		placement: "left",
	},
	{
		target: ".bulkUpload",
		content: "Upload multiple product categories at once using an Excel template.",
		placement: "left",
	},
	{
		target: ".downloadSample",
		content: "Download the Excel template to ensure proper formatting for bulk uploads.",
		placement: "left",
	},
	{
		target: ".main_content",
		content: "This table lists all your product categories with creation dates and organization info.",
		placement: "top",
	},
	{
		target: ".actionMenu",
		content: "Edit existing categories or manage their settings using these action buttons.",
		placement: "left",
	},
];
const SAMPLE_EXCEL_PATH = "/sample_excels/prod_cat_sample.xlsx";
const EXCEL_TYPE = "product_category";

const defaultFilter = {
	pagesize: 10,
	page_no: 1,
};

const ProductCategories = () => {
	const { userPermissions, isFetched } = useUserPermissions();

	const { userDetail, isSuperAdmin } = useUserDetail();
	const { plantId } = usePlantContext();
	const shouldHandlePlant = userDetail?.userType == "superAdmin" || userPermissions?.managePlant?.value;

	const tourRef = useRef();
	const [isTourMode, setIsTourMode] = useState(false);
	const shouldRunTour = !userDetail?.moduleTour?.productCategories;
	const { orgOptions } = useOrgs({}, { skip: !isSuperAdmin });
	const { plantOptions, getPlantDetails, clearPlants } = usePlant();
	// useEffect(() => {
	// 	if (userPermissions?.managePlant?.value) {
	// 		getPlantDetails({});
	// 	}
	// }, [userPermissions]);
	const [isModal, setIsModal] = useState(false);
	const [fetchStats, setFetchStats] = useState(false);
	const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
	const [productCatToDelete, setProductCatToDelete] = useState(null);
	const onModalClose = () => {
		setIsModal(false);
		if (updateDataRef.current) {
			updateDataRef.current = null;
		}
	};
	const onModalOpen = () => setIsModal(true);
	const updateDataRef = useRef(null);
	const filterFields = [
		{
			inputType: "textfield",
			id: "2",
			name: "productCategory",
			type: "text",
			label: "Categories",
			placeholder: "Categories",
			readOnly: false,
			error: "",
			value: "",
		},
	];
	if (userDetail?.userType == "superAdmin") {
		filterFields.push({
			inputType: "dropdown",
			id: "orgId",
			name: "orgId",
			label: "Organization",
			error: "",
			option: orgOptions,
		});
	}
	if (shouldHandlePlant && userDetail?.userType == "superAdmin") {
		filterFields.push({
			inputType: "dropdown",
			id: "plantIds",
			name: "plantIds",
			label: "Warehouse",
			error: "",
			option: plantOptions,
		});
	}
	const filterRef = useRef(defaultFilter);
	if(userDetail.userType !== "superAdmin"){
		filterRef.current.plantIds = plantId;
	}
	const { page_no, pagesize } = filterRef.current;
	const { productCategories, count, isLoading, message, getProdCats } = useProductCategories(userDetail.userType === "superAdmin" ? filterRef.current : null);
	useEffect(()=>{
		if(filterRef.current && userDetail?.userType !== "superAdmin"){
			getProdCats(filterRef.current)
		}	
	}, [plantId])
	const [handleDelete] = useDeleteProductCategoryMutation();
	let actionHandlers = {};
	if (userPermissions?.updateProductCategory?.value) {
		actionHandlers.edit = (id) => {
			updateDataRef.current = productCategories[id];
			setIsModal(true);
		};
	}
	if (userPermissions?.deleteProductCategory?.value) {
		actionHandlers.delete = async (id) => {
			// console.log(id, "delete");
			// const data = productCategories[id];
			// const payload = { deleteId: data._id };
			// const {
			// 	data: { error, message },
			// } = await handleDelete(payload);
			// if (error) {
			// 	toastMessage(false, message);
			// } else {
			// 	onUpdateSuccess();
			// 	toastMessage(true, message);
			// }
			setDeleteConfirmOpen(true);
			setProductCatToDelete(productCategories[id]);
		};
	}
	const handleDeleteConfirm = async () => {
		if (!productCatToDelete) return;

		const payload = { deleteId: productCatToDelete._id };
		const {
			data: { error, message },
		} = await handleDelete(payload);

		if (error) {
			toastMessage(false, message);
		} else {
			onUpdateSuccess();
			toastMessage(true, message);
		}

		setDeleteConfirmOpen(false);
		setProductCatToDelete(null);
	};
	const handleDeleteCancel = () => {
		setDeleteConfirmOpen(false);
		setProductCatToDelete(null);
	};
	let header = ["S.no", "Product Category", "Created On"];
	if (userDetail?.userType == "superAdmin") header.push("Org Name");
	if (userPermissions?.updateProductCategory?.value || userPermissions?.deleteProductCategory?.value) {
		header.push("Action");
	}
	const rows =
		(shouldRunTour || isTourMode ? dummyTourData : productCategories)?.map((d, i) => {
			let row = [];
			row.push(tCell((page_no - 1) * pagesize + i + 1), tCell(d.productCategory), tCell(formatDate(d.created_on)));

			if (userDetail?.userType == "superAdmin") row.push(tCell(d.orgName));

			if (userPermissions?.updateProductCategory?.value || userPermissions?.deleteProductCategory?.value) {
				row.push(
					<div style={{ paddingLeft: "0.5rem" }}>
						<ActionMenu id={i} handlers={actionHandlers} />
					</div>
				);
			}
			return row;
		}) || [];

	const onPageChange = (page_no) => {
		filterRef.current = { ...filterRef.current, page_no: page_no + 1 };
		getProdCats(filterRef.current);
	};
	const onPageSizeChange = (e) => {
		const { value } = e.target;
		filterRef.current = { ...filterRef.current, pagesize: value };
		getProdCats(filterRef.current);
	};

	const onUpdateSuccess = () => {
		getProdCats(filterRef.current);
		setFetchStats((old) => !old);
	};
	const [handleUploadExcel] = useUploadProductCategoryMutation();
	const onBulkExcelUpload = () => {
		fakeFileInput(async (formData) => {
			formData.append("type", EXCEL_TYPE);
			formData.append("plantId", plantId);
			// const payload = {
			// 	file,
			// 	type: EXCEL_TYPE,
			// };
			const {
				data: { error, message },
			} = await handleUploadExcel(formData);
			if (error) {
				toastMessage(false, message);
			} else {
				toastMessage(true, message);
				onUpdateSuccess();
			}
		});
	};

	/**
	 * We use GenericFilter component for all CRUD filters. That component maintains its own state for the filter
	 * and that object is sent here to the handleFilterChange function.
	 * Mutating this _filter object will cause the filter state to change on rerender (It's probably because of object reference in JS. The filter object from the state gets mutated and then the component gets re-rendered  due to any reason and now the state will have the mutated object)
	 * Here we have relationship between Org and Plant. On selecting an org, we will fetch its plant. So in order to clear previous selected plant when selecting different org, we will mutate the _filter object
	 */
	const handleFilterChange = (_filter) => {
		let filter = { ..._filter };

		for (let key in filter) {
			if (!filter[key]) delete filter[key];
		}
		if (userDetail.userType == "superAdmin") {
			if (filter.orgId) {
				// filter.orgId = filter.orgId?.value;
				if (shouldHandlePlant && filter.orgId != filterRef.current.orgId) {
					// when switching organization, we want to
					// - get plants for that org
					// - clear plantIds from the local filter object
					// - clear plantIds from original filter object, mutating the state and clearing the plant dropdown
					delete filter.plantIds;
					delete _filter.plantIds;
					getPlantDetails({ orgId: filter.orgId });
				}
			} else {
				clearPlants();
			}
		}
		// if (filter.plantIds) filter.plantIds = filter.plantIds?.value;

		filter.page_no = 1;
		filter.pagesize = 10;

		if (!isObjectEqual(filterRef.current, filter)) {
			filterRef.current = { ...filter };
			getProdCats(filterRef.current);
		}
	};

	const handleTourStart = () => {
		setIsTourMode(true);
		tourRef.current?.restartTour();
	};
	if (isFetched && userPermissions && Object.keys(userPermissions).length && !userPermissions.getProductCategory?.value) return <Navigate to="/not-authorized" replace />;

	return (
		<div className="contentpanel">
			<CommonTour ref={tourRef} steps={ProductCategoriesTour} moduleName="productCategories" onTourComplete={() => setIsTourMode(false)} />
			<Grid container spacing="0.5rem">
				<Grid item xl={6} lg={6} md={5} sm={12} xs={12}>
					<h1 className="title">
						Product Categories
						<span title="Replay Tour" onClick={handleTourStart} style={{ cursor: "pointer" }}>
							<TourIcon />
						</span>
					</h1>
				</Grid>
				<Grid item xl={6} lg={6} md={7} sm={12} xs={12}>
					<Grid container spacing="0.5rem">
						{userPermissions?.addProductCategory?.value ? (
							<Grid item xl={4} lg={4} md={4} sm={4} xs={12} className="addProductCategory">
								<Button onClick={onModalOpen} text="Add Product Category" style={buttonClasses.lynkitOrangeEmpty} />
							</Grid>
						) : null}
						{userPermissions?.addProductCategory?.value ? (
							<Grid item xl={4} lg={4} md={4} sm={4} xs={12} className="bulkUpload">
								<Button onClick={onBulkExcelUpload} text="Bulk Upload" style={buttonClasses.lynkitOrangeFill} />
							</Grid>
						) : null}
						{userPermissions?.addProductCategory?.value ? (
							<Grid item xl={4} lg={4} md={4} sm={4} xs={12} className="downloadSample">
								<a href={SAMPLE_EXCEL_PATH} download>
									<Button text="Download Sample" style={buttonClasses.lynkitBlackFill} />
								</a>
							</Grid>
						) : null}
					</Grid>
				</Grid>
			</Grid>

			<hr className="bgg" />
			<GenericstatsV2 statsFor={"productCategories"} fetchStats={fetchStats} plantId={plantId}/>
			<div className="cust-row flex-algn-cent">
				<Genericfilter filterFields={filterFields} onFilterChange={debounce((filter) => handleFilterChange(filter), 500)} addOnClear/>
			</div>
			<div className="main_content">
				<GenericTable
					header={header}
					rows={rows}
					pageCount={count}
					pageNo={filterRef.current?.page_no}
					limit={filterRef.current?.pagesize}
					onPageChange={onPageChange}
					onPageSizeChange={onPageSizeChange}
					isLoading={isLoading}
				/>
			</div>

			{isModal && <AddProductCategory open={isModal} onClose={onModalClose} updateData={updateDataRef.current} onUpdateSuccess={onUpdateSuccess} />}
			<ConfirmationDialog open={deleteConfirmOpen} handleClose={handleDeleteCancel} handleSubmit={handleDeleteConfirm} title="Delete Product Category" submitText="Delete">
				Are you sure you want to delete this product category? This action cannot be undone.
			</ConfirmationDialog>
		</div>
	);
};

export default ProductCategories;

const defaultForm = {
	productCategory: "",
	updateId: undefined,
	orgId: undefined,
	plantId: "",
	isApprovalRequired: false,
	checkpoints: [],
	prefix: "",
	productCategoryId: "",
};

function fillUpdateData(data) {
	return {
		productCategory: data.productCategory,
		updateId: data._id,
		orgId: data.orgId,
		plantId: data.plantId || "",
		isApprovalRequired: data.checkpoints.length > 0 ? true : !!data.isApprovalRequired,
		checkpoints: data.checkpoints || [],
		prefix: data.prefix || "",
		productCategoryId: data.productCategoryId || "",
	};
}

function AddProductCategory({ onClose, open, updateData, onUpdateSuccess }) {
	const [formData, setFormData] = useState(updateData ? fillUpdateData(updateData) : defaultForm);
	const [error, setError] = useState({});
	const { userDetail, isSuperAdmin } = useUserDetail();
	const { userPermissions } = useUserPermissions();

	const { orgOptions } = useOrgs({}, { skip: !isSuperAdmin });
	const orgValue = orgOptions?.find((_) => _.value == formData.orgId);
	const { plantId } = usePlantContext();
	const { plantOptions, clearPlants, getPlantDetails } = usePlant();
	useEffect(() => {
		getPlantDetails({orgId:formData.orgId || userDetail?.orgId});
	}, [formData.orgId]);
	const plantValue = plantOptions.find((_) =>_.value == formData.plantId);

	const filterRef = useRef({ orgId: updateData?.orgId });
	// const { checkpointOptions, getCheckpoints } = useCheckpoints(filterRef.current);
	const { checkpointOptions, getCheckpoints } = useCheckpoints({plantIds: formData?.plantId || plantId});
	let checkpointValues = checkpointOptions?.filter((chk) => formData?.checkpoints?.length > 0 && formData.checkpoints?.find((fchk) => fchk?.value == chk.value || fchk == chk.value));

	const handleInput = (e) => {
		let { name, value, checked, type } = e.target;
		value = type == "checkbox" ? checked : value;
		// console.log(name, value, type, checked);
		let extraValue = {};
		if (name == "isApprovalRequired" && !value) {
			extraValue = { checkpoints: [] };
		}
		if (name == "isApprovalRequired" && formData?.orgId) {
			filterRef.current = { ...filterRef.current, orgId: formData?.orgId || "" };
		}
		setFormData({ ...formData, [name]: value, ...extraValue });
	};
	const onDropdownChange = (option, name) => {
		let value = Array.isArray(option) ? option.map((_) => _.value) : option?.value || "";
		handleInput({ target: { name, value } });
		if (name == "orgId") {
			if (formData.isApprovalRequired) {
				filterRef.current = { ...filterRef.current, orgId: option?.value || "" };
			}
			if (value) {
				getPlantDetails({ orgId: value });
			} else {
				clearPlants();
			}
		}
		if (name == "plantId") {
			if(value){
				getCheckpoints({plantIds:value})
			}
		}
	};

	const [handleAdd, { isLoading: isAdding }] = useAddProductCategoryMutation();
	const [handleUpdate, { isLoading: isUpdating }] = useUpdateProductCategoryMutation();
	const handleFormSubmit = async () => {
		const payload = { ...formData, orgName: orgValue?.label || userDetail.orgName , plantId: userDetail?.userType === "superAdmin" ? formData.plantId : plantId };
		// console.log("Paylaod", payload)
		const {
			data: { error, message },
		} = updateData ? await handleUpdate(payload) : await handleAdd(payload);
		if (error) {
			toastMessage(false, message);
		} else {
			toastMessage(true, message);
			onUpdateSuccess();
			handleClose();
		}
	};
	const handleFormValidation = () => {
		let error = {};
		if (userDetail?.userType == "superAdmin" && !formData.orgId) error.orgId = "Organization name is required";
		if (!formData.plantId.length && userDetail?.userType == "superAdmin") error.plantId = "Warehouse is required";
		if (!formData.productCategory) error.productCategory = "Product Category is required";

		if (Object.keys(error).length) {
			setError(error);
		} else {
			handleFormSubmit();
		}
	};
	const handleClose = () => {
		setFormData(defaultForm);
		setError({});
		onClose();
	};

	// console.log('formData', formData);
	return (
		<Dialog
			size="xs"
			open={open}
			handleClose={handleClose}
			handleSubmit={handleFormValidation}
			title={updateData ? "Update Product Category" : "Add Product Category"}
			isSubmitDisabled={isAdding || isUpdating}
		>
			<form>
				<div className="form-inputs mt-2">
					{userDetail?.userType == "superAdmin" ? (
						<Dropdown id="orgId" name="orgId" label="Organization Name" onChange={onDropdownChange} options={orgOptions} value={orgValue} error={error.orgId} required />
					) : null}
					{userDetail?.userType == "superAdmin" ? <Dropdown id="plantIdAdd" name="plantId" label="Warehouse" onChange={onDropdownChange} options={plantOptions} value={plantValue} required error={error.plantId} /> :null}
					<Input
						label="Product Category"
						placeholder="Enter Product Category"
						name="productCategory"
						value={formData.productCategory}
						onChange={handleInput}
						error={error.productCategory}
						required
					/>
					<Input label="Prefix" placeholder="Enter Prefix" name="prefix" value={formData.prefix} onChange={handleInput} />
					<Input label="Product Category Id" placeholder="Enter Product Category Id" name="productCategoryId" value={formData.productCategoryId} onChange={handleInput} />
					<Checkbox
						label="Send Approval Request from Checkpoint(s)"
						id="approvalRequired"
						name="isApprovalRequired"
						checked={formData.isApprovalRequired}
						onChange={handleInput}
						size="medium"
					/>
					{formData.isApprovalRequired ? (
						<Dropdown
							id="checkpoints"
							name="checkpoints"
							label="Select Checkpoints"
							onChange={onDropdownChange}
							options={checkpointOptions}
							value={checkpointValues}
							error={error.checkpoints}
							multiple
						/>
					) : null}
				</div>
			</form>
		</Dialog>
	);
}
